import styled from 'styled-components';
import { BREADCRUMB_MARGIN } from '../styled.js';
import { IconButton } from '../../buttons/IconButton/index.js';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';

var StyledIconButton = styled(IconButton).withConfig({
  displayName: "StyledIconButton",
  componentId: "sc-1ucskv3-0"
})(["position:relative;color:", ";font-size:", ";margin-right:", ";[data-icon='falcon']{width:1rem;height:1rem;}&::after{content:'/';width:", ";text-align:center;position:absolute;right:calc(-1 * ", ");}"], themeGet('color.100'), themeGet('fontSize.medium'), BREADCRUMB_MARGIN, BREADCRUMB_MARGIN, BREADCRUMB_MARGIN);

export { StyledIconButton };
